import styled from 'styled-components'

export const StyledSpecsAdvanceOptionFilter = styled.div`
  padding: 15px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 15px;
`
